import React, { Suspense, useRef, useEffect, useMemo, useState } from "react";
import "./App.css";
import * as tf from "@tensorflow/tfjs";
import * as facemesh from "@tensorflow-models/face-landmarks-detection";
import * as THREE from "three";
import { Canvas, useFrame, useThree, useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import Webcam from "react-webcam";

const Model = () => {
  const gltf = useLoader(GLTFLoader, "./gltf/testrm1.glb");
  return (
    <>
      <primitive
        object={gltf.scene}
        scale={1}
        position={[-10, -40, 10]}
        rotation={[0, -0.6, 0]}
      />
    </>
  );
};

function App() {
  const webcamRef = useRef(null);
  let [hasWebcam, setHasWebcam] = useState(false);
  const cameraRef = useRef(null);

  return (
    <div className="App">
      <Webcam
        ref={webcamRef}
        onLoadedData={() => {
          setHasWebcam(true);
        }}
        style={{
          position: "absolute",
          marginLeft: "auto",
          marginRight: "auto",
          left: 0,
          right: 0,
          textAlign: "center",
          zindex: 9,
          width: 0,
          height: 0,
        }}
      />

      <div
        style={{
          background: "black",
          margin: "0 auto",
          width: "100%",
          position: "absolute",
          height: "100%",
        }}
      >
        <Suspense fallback={<div>loading...</div>}>
          <Canvas
            camera={{ ref: cameraRef }}
            shadows={true}
            gl={{ shadowMap: { type: THREE.PCFSoftShadowMap } }}
          >
            {hasWebcam ? (
              <FaceDetector
                video={webcamRef.current.video}
                camera={cameraRef}
              />
            ) : (
              false
            )}
            <Model />
            <pointLight
              position={[0, 5, 10]}
              color={"#ffffff"}
              intensity={0.5}
              castShadow
              shadow-mapSize-height={512}
              shadow-mapSize-width={512}
              shadow-camera-near={2}
              shadow-camera-far={300}
            />

            {/* <pointLight
              position={[40, 10, -40]}
              color={"#ffffff"}
              intensity={2}
              castShadow
              shadow-mapSize-height={512}
              shadow-mapSize-width={512}
              shadow-camera-near={2}
              shadow-camera-far={300}
            /> */}
          </Canvas>
        </Suspense>
      </div>
    </div>
  );
}

function FaceDetector({ video, camera }) {
  let net = useMemo(async () => {
    let x = await facemesh.load(facemesh.SupportedPackages.mediapipeFacemesh);
    return x;
  }, []);

  let [hasNet, setHasNet] = useState(false);
  let cameraRef;

  useFrame(() => {
    if (hasNet) {
      detect(hasNet);
    }
  });

  useThree(({ camera }) => {
    cameraRef = camera;
  });

  let pointRefs = [useRef(), useRef(), useRef()];

  useEffect(() => {
    net.then((result) => {
      setHasNet(result);
    });
  }, [net]);

  const detect = async (net) => {
    const face = await net.estimateFaces({ input: video });
    if (face.length > 0) {
      let points = [0, 27, 257].map((n) =>
        face[0].scaledMesh[n].map((n, i) => {
          //map the indexes into the scaledMesh which contains the x, y, z coordinates
          //then, map the x y z coordinates accordingly to scale
          if (i === 0) {
            // x value
            return (n - 320) * -0.02; //320 = 640px width / 2 and multiply by a multiplier
          }

          if (i === 1) {
            // y value
            return (n - 240) * -0.02;
          }

          return n;
        })
      );
      points.forEach((point, i) => {
        pointRefs[i].current.position.set(point[0], point[1], point[2]);
      });

      cameraRef.position.set(points[0][0], points[0][1] + 2, 20);
      cameraRef.lookAt(-1, 1, 10);
    }
  };

  return (
    <>
      <mesh ref={pointRefs[0]} scale={[0, 0, 0]}>
        <boxGeometry />
        <meshBasicMaterial color="green" />
      </mesh>
      <mesh ref={pointRefs[1]} scale={[0, 0, 0]}>
        <boxGeometry />
        <meshBasicMaterial color="blue" />
      </mesh>
      <mesh ref={pointRefs[2]} scale={[0, 0, 0]}>
        <boxGeometry />
        <meshBasicMaterial color="red" />
      </mesh>
    </>
  );
}

export default App;
